import type { Achievement } from "../achievement.types";

// Awarded from word-collection progress, not from a single game report:
// see ../collectionAchievements.ts, which raises the counter to the number
// of completed collections after each game.
export const wordCollectorAchievement: Achievement = {
  id: "wordCollector",
  name: "Word Collector",
  description: "Completed a word collection.",
  // Counts once per collection: every word in it played.
  icon: "book-open-variant",
  isProgressive: true,

  check: () => false,
};
